<template>
  <div>
    <el-dialog
      width="1000px"
      :visible="true"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :modal="false"
      :before-close="close"
    >
      <template #title>
        <div class="el-dialog__title">
          {{ $t('CampaignForm_Preview_Send_Preview') }}
        </div>
      </template>
      <label class="inline">{{
        $t('CampaignForm_Preview_Send_Preview_To')
      }}</label>
      <form-item class="inline" prop="recipient_emails">
        <el-select
          v-model="recipient_emails"
          :multiple-limit="10"
          multiple
          filterable
          allow-create
          default-first-option
        >
          <el-option
            v-for="item in savedOptions"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </form-item>
      <div v-loading="loading">
        <div class="message-details-ct">
          <div class="row">
            <div>
              <span class="from">
                {{
                  $t('CampaignForm_Preview_ContentMessageDetails_Email_From')
                }}
              </span>
              <span class="from-details" v-html="content.from_name" />
              <span v-if="content.from_address" class="from-details-extended">
                <!-- eslint-disable-next-line -->
            <{{ content.from_address }}>
              </span>
            </div>
            <span class="subject">
              {{
                $t('CampaignForm_Preview_ContentMessageDetails_Email_Subject')
              }}
            </span>
            <span class="subject-details" v-html="content.subject" />
          </div>
        </div>
        <div class="preview-frame">
          <iframe
            ref="iframeRef"
            :srcdoc="content.html"
            class="email-preview"
            @load="isIframeLoaded"
          />
        </div>
      </div>
      <div class="send-button">
        <el-button
          :disabled="disableInput"
          icon="el-icon-s-promotion"
          @click="sendPreview"
          type="primary"
        >
          {{ $t('CampaignForm_Preview_Send_Preview_Send') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FormItem from '@/common/components/form/FormItem.vue'
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'
import { channelTypes } from '@/modules/campaign-manage/enum/Labels'
import { Message } from 'element-ui'

export default {
  name: 'PreviewSendDialog',
  components: { FormItem },
  mounted() {
    if (
      this.user &&
      this.user.email &&
      !this.recipient_emails.find(email => email === this.user.email)
    ) {
      this.recipient_emails.push(this.user.email)
    }
    this.getPreview()
  },
  data() {
    return {
      recipient_emails: [],
      savedOptions: [],
      content: {},
      loading: true
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      required: true
    },
    preview: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(['user']),
    disableInput() {
      return this.loading || !this.recipient_emails.length
    }
  },
  watch: {
    recipient_emails(value) {
      this.savedOptions = [...new Set([...(value || []), ...this.savedOptions])]
    }
  },
  methods: {
    close() {
      this.$emit('update:dialogVisible', false)
    },
    sendPreview() {
      this.loading = true
      RestApi(
        projectEndpoint({
          method: 'post',
          url: `campaign-messages/send-preview`,
          data: {
            campaign: this.preview.campaign,
            message_type: channelTypes.email,
            variant_key: this.preview.variant_key,
            workflow_email: this.preview.workflow_email,
            language: this.preview.language,
            profile_id: this.preview.profile_id,
            customAttributes: this.preview.customAttributes,
            preview_mode: false,
            recipient_emails: this.recipient_emails
          }
        })
      )
        .then(() => {
          this.$message({
            message: this.$t('CampaingForm_Preview_Send_Preview_Sent'),
            type: 'success',
            duration: 2000
          })
          this.close()
        })
        .catch(error => {
          Message.closeAll()
          this.$message({
            message: error.message,
            type: 'error',
            duration: 5000
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    isIframeLoaded(e) {
      let height = e.target.contentWindow.document.documentElement.scrollHeight
      e.target.style.height = `${height}px`
    },
    getPreview() {
      this.loading = true
      RestApi(
        projectEndpoint({
          method: 'post',
          url: `campaign-messages/preview`,
          data: {
            campaign: this.preview.campaign,
            message_type: channelTypes.email,
            variant_key: this.preview.variant_key,
            workflow_email: this.preview.workflow_email,
            language: this.preview.language,
            profile_id: this.preview.profile_id,
            customAttributes: this.preview.customAttributes,
            preview_mode: 0
          }
        })
      )
        .then(({ data }) => {
          this.content = data['message']
        })
        .catch(error => {
          Message.closeAll()
          this.$message({
            message: error.message,
            type: 'error',
            duration: 5000
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.inline {
  display: inline-block;
}
.el-form-item {
  margin-right: 5px;
  width: 90%;
}
.subject-details,
.from-details {
  margin-left: 20px;
  font-weight: 600;
}

.from-details {
  margin-left: 61px;
}

.from-details-extended {
  margin-left: 20px;
  color: #7e8596;
}

.preview-frame {
  position: relative;
  min-height: 400px;
  background-color: #fff;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 20px;
  border-top: 1px solid #c2c7d3;
  border-bottom: 1px solid #c2c7d3;
  .email-preview {
    background-color: #ffffff;
    width: 100%;
    height: 100%;
    border: 0;
    box-sizing: border-box;
    max-height: 500px;
    overflow: scroll;
  }
}

.send-button {
  display: flex;
  justify-content: right;
}

/deep/ .el-dialog__header {
  background-color: #1d87c8;
}

/deep/ .el-dialog__headerbtn {
  border-color: #ffffff;
}

/deep/ .el-dialog__title {
  color: #ffffff;
}

/deep/ .el-dialog__headerbtn i {
  color: #ffffff;
  -webkit-text-stroke-color: #ffffff;
}

/deep/ .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/ .el-dialog {
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/preview/PreviewSendDialog.vue